// extracted by mini-css-extract-plugin
module.exports = {"list":"FilterButtonsTemplate_list__hpgMe","button":"FilterButtonsTemplate_button__YGrDd"};